import { FETCH_CUSTOMER_HISTORY_SUCCESS, AGENT_CANCEL_DOWNLOAD_SUCCESS } from "../actions/types";

const initialState = {
  hasDeleted: "",
  deleteDateOfRequest: "",
  nextRollOffDateAffidavitDownload: "",
  noOfAffidavitDownloadRemaining: null,
  elementsData: [],
  custRequestedBefore: {
    requestType: "",
    dateOfRequest: "",
    downloadAvailabilityDeadline: ""
  }
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CUSTOMER_HISTORY_SUCCESS:
      return {
        ...state,
        ...payload
      };
    case AGENT_CANCEL_DOWNLOAD_SUCCESS:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};
